import { Locale } from 'chaika-enums';
export const serviceModule = {
    serviceGroupSettings: {
        [Locale.Ru]: `Настройка групп услуг`,
        [Locale.Am]: `Ծառայությունների խմբերի կարգավորում`,
        [Locale.En]: `Setting up service groups`,
        [Locale.Pt]: 'Configurando grupos de serviço',
        [Locale.Ge]: `Setting up service groups`,
    },
    nomenclature: {
        [Locale.Ru]: `Номенклатура`,
        [Locale.Am]: `Անվանացանկ`,
        [Locale.En]: `Nomenclature`,
        [Locale.Pt]: `Nomenclatura`,
        [Locale.Ge]: `Nomenclature`,
    },
    nameCategoryRequiredText: {
        [Locale.Ru]: `Название и категория - обязательные для заполнения поля`,
        [Locale.Am]: `Անվանումը և կատեգորիան լրացման համար պարտադիր դաշտեր են`,
        [Locale.En]: `Name and category are required fields.`,
        [Locale.Pt]: 'Nome e categoria são campos obrigatórios.',
        [Locale.Ge]: `Name and category are required fields.`,
    },
    linkShouldBeLinkText: {
        [Locale.Ru]: `Ссылка на описание должна быть ссылкой`,
        [Locale.Am]: `Նկարագրության հղումը պետք է լինի հղում`,
        [Locale.En]: `The description link should be a link`,
        [Locale.Pt]: 'O link da descrição deve ser um link',
        [Locale.Ge]: `The description link should be a link`,
    },
    dentistry: {
        [Locale.Ru]: `Стоматология`,
        [Locale.Am]: `Ստոմատոլոգիա`,
        [Locale.En]: `Dentistry`,
        [Locale.Pt]: 'Odontologia',
        [Locale.Ge]: `Dentistry`,
    },
    laboratoryWitch: {
        [Locale.Ru]: `Лабораторные`,
        [Locale.Am]: `Լաբորատոր`,
        [Locale.En]: `Laboratory`,
        [Locale.Pt]: `Laboratório`,
        [Locale.Ge]: `Laboratory`,
    },
    technical: {
        [Locale.Ru]: `Техническая`,
        [Locale.Am]: `Տեխնիկական`,
        [Locale.En]: `Technical`,
        [Locale.Pt]: 'Técnico',
        [Locale.Ge]: `Technical`,
    },
    policlinika: {
        [Locale.Ru]: `Поликлиника`,
        [Locale.Am]: `Պոլիկլինիկա`,
        [Locale.En]: `Clinic`,
        [Locale.Pt]: 'Clínica',
        [Locale.Ge]: 'კლინიკა',
    },
    radiodiagnosis: {
        [Locale.Ru]: `Лучевая диагностика`,
        [Locale.Am]: `Ճառագայթային ախտորոշում`,
        [Locale.En]: `Radiodiagnosis`,
        [Locale.Pt]: 'Diagnóstico',
        [Locale.Ge]: `Radiodiagnosis`,
    },
    ultrasoundDiagnostics: {
        [Locale.Ru]: `Ультразвуковая диагностика`,
        [Locale.Am]: `Ուլտրաձայնային ախտորոշում`,
        [Locale.En]: `Ultrasound diagnostics`,
        [Locale.Pt]: 'Diagnóstico de ultrassom',
        [Locale.Ge]: `Ultrasound diagnostics`,
    },
    hospital: {
        [Locale.Ru]: `Стационар`,
        [Locale.Am]: `Ստացիոնար`,
        [Locale.En]: `Hospital`,
        [Locale.Pt]: 'Hospital',
        [Locale.Ge]: `Hospital`,
    },
    materialsAndPreparations: {
        [Locale.Ru]: `Материалы и препараты`,
        [Locale.Am]: `Նյութեր և պրեպարատներ`,
        [Locale.En]: `Materials and preparations`,
        [Locale.Pt]: 'Materiais e preparações',
        [Locale.Ge]: `Materials and preparations`,
    },
    oneCProduct: {
        [Locale.Ru]: `Товары`,
        [Locale.Am]: `Ապրանքներ`,
        [Locale.En]: `Goods`,
        [Locale.Pt]: 'Bens',
        [Locale.Ge]: `Goods`,
    },
    toListOfSets: {
        [Locale.Ru]: `К списку наборов`,
        [Locale.Am]: `Դեպի հավաքածուների ցանկ`,
        [Locale.En]: `To the list of sets`,
        [Locale.Pt]: 'Para a lista de conjuntos',
        [Locale.Ge]: `To the list of sets`,
    },
    serviceMustSpecified: {
        [Locale.Ru]: `Должна быть указана услуга`,
        [Locale.Am]: `Պետք է նշվի ծառայությունը`,
        [Locale.En]: `The service must be specified`,
        [Locale.Pt]: 'O serviço deve ser especificado',
        [Locale.Ge]: `The service must be specified`,
    },
    serviceSettings: {
        [Locale.Ru]: `Настройки услуг`,
        [Locale.Am]: `Ծառայությունների կարգավորումներ`,
        [Locale.En]: `Service settings`,
        [Locale.Pt]: 'Configurações de serviço',
        [Locale.Ge]: `Service settings`,
    },
    addPriceToPriceList: {
        [Locale.Ru]: `Добавить цены в прайс лист`,
        [Locale.Am]: `Ավելացնել գներ գնացուցակում`,
        [Locale.En]: `Add prices to price list`,
        [Locale.Pt]: 'Adicionar preços à lista de preços',
        [Locale.Ge]: `Add prices to price list`,
    },
    compound: {
        [Locale.Ru]: `Состав`,
        [Locale.Am]: `Կազմ`,
        [Locale.En]: `Compound`,
        [Locale.Pt]: 'Composto',
        [Locale.Ge]: `Compound`,
    },
    creatingCompositeService: {
        [Locale.Ru]: `Создание составной услуги`,
        [Locale.Am]: `Բաղադրյալ ծառայության ստեղծում`,
        [Locale.En]: `Creating a Composite Service`,
        [Locale.Pt]: 'Criando um serviço composto',
        [Locale.Ge]: `Creating a Composite Service`,
    },
    editingCompositeService: {
        [Locale.Ru]: `Редактирование составной услуги`,
        [Locale.Am]: `Բաղադրյալ ծառայության խմբագրում`,
        [Locale.En]: `Editing a Composite Service`,
        [Locale.Pt]: 'Editando um serviço composto',
        [Locale.Ge]: `Editing a Composite Service`,
    },
    serviceComposition: {
        [Locale.Ru]: `Состав услуги`,
        [Locale.Am]: `Ծառայության կազմ`,
        [Locale.En]: `Service composition`,
        [Locale.Pt]: 'Composição do serviço',
        [Locale.Ge]: `Service composition`,
    },
    addChangePrice: {
        [Locale.Ru]: `Добавить/изменить цену`,
        [Locale.Am]: `Ավելացնել/փոփոխել գինը`,
        [Locale.En]: `Add/Change Price`,
        [Locale.Pt]: 'Adicionar/alterar preço',
        [Locale.Ge]: `Add/Change Price`,
    },
    addPlanned: {
        [Locale.Ru]: `Добавить планируемую`,
        [Locale.Am]: `Ավելացնել պլանավորվողը`,
        [Locale.En]: `Add planned`,
        [Locale.Pt]: 'Adicionar planejado',
        [Locale.Ge]: `Add planned`,
    },
    plannedPrice: {
        [Locale.Ru]: `Планируемая цена`,
        [Locale.Am]: `Պլանավորվող գին`,
        [Locale.En]: `Planned price`,
        [Locale.Pt]: 'Preço planejado',
        [Locale.Ge]: `Planned price`,
    },
    archiveOrDelete: {
        [Locale.Ru]: `В Архив/Удалить`,
        [Locale.Am]: `Արխիվ/Ջնջել`,
        [Locale.En]: `To Archive/Delete`,
        [Locale.Pt]: 'Para arquivar/excluir',
        [Locale.Ge]: `To Archive/Delete`,
    },
    addPriceList: {
        [Locale.Ru]: `Добавить прайс лист`,
        [Locale.Am]: `Ավելացնել գնացուցակ`,
        [Locale.En]: `Add price list`,
        [Locale.Pt]: 'Adicionar lista de preços',
        [Locale.Ge]: `Add price list`,
    },
    insurancePriceLists: {
        [Locale.Ru]: `Прайс листы страховых`,
        [Locale.Am]: `Ապահովագրականների գնացուցակներ`,
        [Locale.En]: `Insurance price lists`,
        [Locale.Pt]: 'Listas de preços de seguros',
        [Locale.Ge]: `Insurance price lists`,
    },
    plannedDate: {
        [Locale.Ru]: `Планируемая дата`,
        [Locale.Am]: `Պլանավորվող ամսաթիվ`,
        [Locale.En]: `Planned date`,
        [Locale.Pt]: 'Data planejada',
        [Locale.Ge]: `Planned date`,
    },
    updatedAt: {
        [Locale.Ru]: `Дата обновления`,
        [Locale.Am]: `Թարմացման ամսաթիվ`,
        [Locale.En]: `Date of update`,
        [Locale.Pt]: 'Data da atualização',
        [Locale.Ge]: `Date of update`,
    },
    creatingPriceList: {
        [Locale.Ru]: `Создание прайс листа`,
        [Locale.Am]: `Գնացուցակի ստեղծում`,
        [Locale.En]: `Creating a price list`,
        [Locale.Pt]: 'Criando uma lista de preços',
        [Locale.Ge]: `Creating a price list`,
    },
    editingPriceList: {
        [Locale.Ru]: `Редактирование прайс листа`,
        [Locale.Am]: `Գնացուցակի խմբագրում`,
        [Locale.En]: `Editing the price list`,
        [Locale.Pt]: 'Editando a lista de preços',
        [Locale.Ge]: `Editing the price list`,
    },
    presentTimeShort: {
        [Locale.Ru]: `н-в.`,
        [Locale.Am]: `ներկ.`,
        [Locale.En]: `p-t.`,
        [Locale.Pt]: 'p-t.',
        [Locale.Ge]: `p-t.`,
    },
    presentTime: {
        [Locale.Ru]: `настоящее время`,
        [Locale.Am]: `ներկա ժամանակ`,
        [Locale.En]: `present time`,
        [Locale.Pt]: 'tempo presente',
        [Locale.Ge]: `present time`,
    },
    titleInEnglish: {
        [Locale.Ru]: `Название на английском`,
        [Locale.Am]: `Անվանում անգլերենով`,
        [Locale.En]: `Title in English`,
        [Locale.Pt]: 'Título em inglês',
        [Locale.Ge]: `Title in English`,
    },
    whoAddedPrice: {
        [Locale.Ru]: `Кто добавил цену`,
        [Locale.Am]: `Ով է ավելացրել գինը`,
        [Locale.En]: `Who added the price?`,
        [Locale.Pt]: 'Quem adicionou o preço?',
        [Locale.Ge]: `Who added the price?`,
    },
    plannedPrices: {
        [Locale.Ru]: `Планируемые цены`,
        [Locale.Am]: `Պլանավորվող գներ`,
        [Locale.En]: `Planned prices`,
        [Locale.Pt]: 'Preços planejados',
        [Locale.Ge]: `Planned prices`,
    },
    activePrices: {
        [Locale.Ru]: `Активные цены`,
        [Locale.Am]: `Ակտիվ գներ`,
        [Locale.En]: `Active prices`,
        [Locale.Pt]: 'Preços ativos',
        [Locale.Ge]: `Active prices`,
    },
    archivePrices: {
        [Locale.Ru]: `Архивные цены`,
        [Locale.Am]: `Արխիվային գներ`,
        [Locale.En]: `Archive prices`,
        [Locale.Pt]: 'Preços de arquivo',
        [Locale.Ge]: `Archive prices`,
    },
    priceForService: {
        [Locale.Ru]: `Цена на услугу`,
        [Locale.Am]: `Ծառայության գին`,
        [Locale.En]: `Price for the service`,
        [Locale.Pt]: 'Preço pelo serviço',
        [Locale.Ge]: `Price for the service`,
    },
    addGroup: {
        [Locale.Ru]: `Добавить группу`,
        [Locale.Am]: `Ավելացնել խումբ`,
        [Locale.En]: `Add group`,
        [Locale.Pt]: 'Adicionar grupo',
        [Locale.Ge]: `Add group`,
    },
    idAutomaticallyText: {
        [Locale.Ru]: `ID будет присвоен автоматически`,
        [Locale.Am]: `ID-ն կշնորհվի ավտոմատ`,
        [Locale.En]: `ID will be assigned automatically`,
        [Locale.Pt]: 'O ID será atribuído automaticamente',
        [Locale.Ge]: `ID will be assigned automatically`,
    },
    titleInRussian: {
        [Locale.Ru]: `Название на русском`,
        [Locale.Am]: `Անվանում ռուսերենով`,
        [Locale.En]: `Title in Russian`,
        [Locale.Pt]: 'Título em russo',
        [Locale.Ge]: `Title in Russian`,
    },
    category: {
        [Locale.Ru]: `Категория`,
        [Locale.Am]: `Կատեգորիա`,
        [Locale.En]: `Category`,
        [Locale.Pt]: 'Categoria',
        [Locale.Ge]: 'კატეგორია',
    },
    charAndReq: {
        [Locale.Ru]: `Характеристики и требования`,
        [Locale.Am]: `Բնութագրեր և պահանջներ`,
        [Locale.En]: `Characteristics and requirements`,
        [Locale.Pt]: 'Características e requisitos',
        [Locale.Ge]: `Characteristics and requirements`,
    },
    complexService: {
        [Locale.Ru]: `Сложная услуга`,
        [Locale.Am]: `Բարդ ծառայություն`,
        [Locale.En]: `Complex service`,
        [Locale.Pt]: 'Serviço complexo',
        [Locale.Ge]: `Complex service`,
    },
    IDS: {
        [Locale.Ru]: `ИДС`,
        [Locale.Am]: `Տեղեկացված համաձայնություն`,
        [Locale.En]: `IDS`,
        [Locale.Pt]: 'IDs',
        [Locale.Ge]: `IDS`,
    },
    mandatoryIDS: {
        [Locale.Ru]: `ИДС обязательно`,
        [Locale.Am]: `Տեղեկացված համաձայնությունը պարտադիր է`,
        [Locale.En]: `IDS is mandatory`,
        [Locale.Pt]: 'IDS é obrigatório',
        [Locale.Ge]: `IDS is mandatory`,
    },
    passportConfirmation: {
        [Locale.Ru]: `Подтверждение паспортных данных`,
        [Locale.Am]: `Անձնագրային տվյալների հաստատում`,
        [Locale.En]: `Confirmation of passport data`,
        [Locale.Pt]: 'Confirmação dos dados do passaporte',
        [Locale.Ge]: `Confirmation of passport data`,
    },
    additionalConfirmation: {
        [Locale.Ru]: `Подтверждение дополнительных данных`,
        [Locale.Am]: `Լրացուցիչ տվյալների հաստատում`,
        [Locale.En]: `Confirmation of additional data`,
        [Locale.Pt]: 'Confirmação de dados adicionais',
        [Locale.Ge]: `Confirmation of additional data`,
    },
    VAT: {
        [Locale.Ru]: `НДС`,
        [Locale.Am]: `ԱԱՀ`,
        [Locale.En]: `VAT`,
        [Locale.Pt]: 'CUBA',
        [Locale.Ge]: `VAT`,
    },
    descriptionLink: {
        [Locale.Ru]: `Ссылка на описание`,
        [Locale.Am]: `Նկարագրության հղում`,
        [Locale.En]: `The description link`,
        [Locale.Pt]: 'O link da descrição',
        [Locale.Ge]: `The description link`,
    },
    notTaxable: {
        [Locale.Ru]: `Не облагается`,
        [Locale.Am]: `Չի հարկվում`,
        [Locale.En]: `Not taxable`,
        [Locale.Pt]: 'Não tributável',
        [Locale.Ge]: `Not taxable`,
    },
    editingService: {
        [Locale.Ru]: `Редактирование услуги`,
        [Locale.Am]: `Ծառայության խմբագրում`,
        [Locale.En]: `Editing a service`,
        [Locale.Pt]: 'Editando um serviço',
        [Locale.Ge]: `Editing a service`,
    },
    newSpecialty: {
        [Locale.Ru]: `Новая специальность`,
        [Locale.Am]: `Նոր մասնագիտություն`,
        [Locale.En]: `New specialty`,
        [Locale.Pt]: 'Nova especialidade',
        [Locale.Ge]: `New specialty`,
    },
    esitingSpecialty: {
        [Locale.Ru]: `Редактирование специальности`,
        [Locale.Am]: `Մասնագիտության խմբագրում`,
        [Locale.En]: `Editing a specialty`,
        [Locale.Pt]: 'Editando uma especialidade',
        [Locale.Ge]: `Editing a specialty`,
    },
    doctoralSpecialty: {
        [Locale.Ru]: `Докторская специальность`,
        [Locale.Am]: `Բժշկական մասնագիտություն`,
        [Locale.En]: `Doctoral specialty`,
        [Locale.Pt]: 'Especialidade de doutorado',
        [Locale.Ge]: `Doctoral specialty`,
    },
    diagnosticSpecialty: {
        [Locale.Ru]: `Диагностическая специальность`,
        [Locale.Am]: `Ախտորոշիչ մասնագիտություն`,
        [Locale.En]: `Diagnostic specialty`,
        [Locale.Pt]: 'Especialidade diagnóstica',
        [Locale.Ge]: `Diagnostic specialty`,
    },
    defaultService: {
        [Locale.Ru]: `Услуга по умолчанию`,
        [Locale.Am]: `Լռելյայն ծառայություն`,
        [Locale.En]: `Default service`,
        [Locale.Pt]: 'Serviço padrão',
        [Locale.Ge]: `Default service`,
    },
    defaultOnlineService: {
        [Locale.Ru]: `Online услуга по умолчанию`,
        [Locale.Am]: `Լռելյայն online ծառայություն`,
        [Locale.En]: `Online service by default`,
        [Locale.Pt]: 'Serviço online por padrão',
        [Locale.Ge]: `Online service by default`,
    },
    newTag: {
        [Locale.Ru]: `Новый тег`,
        [Locale.Am]: `Նոր պիտակ`,
        [Locale.En]: `New tag`,
        [Locale.Pt]: 'Nova etiqueta',
        [Locale.Ge]: `New tag`,
    },
    editTag: {
        [Locale.Ru]: `Редактирование тега`,
        [Locale.Am]: `Պիտակի խմբագրում`,
        [Locale.En]: `Edit tag`,
        [Locale.Pt]: 'Editar etiqueta',
        [Locale.Ge]: `Edit tag`,
    },
    createLaboratoryService: {
        [Locale.Ru]: `Создание лабораторной услуги`,
        [Locale.Am]: `Լաբորատոր ծառայության ստեղծում`,
        [Locale.En]: `Creating a Laboratory Service`,
        [Locale.Pt]: 'Criando um serviço de laboratório',
        [Locale.Ge]: `Creating a Laboratory Service`,
    },
    editLaboratoryService: {
        [Locale.Ru]: `Редактирование лабораторной услуги`,
        [Locale.Am]: `Լաբորատոր ծառայության խմբագրում`,
        [Locale.En]: `Editing a Laboratory Service`,
        [Locale.Pt]: 'Editando um serviço de laboratório',
        [Locale.Ge]: `Editing a Laboratory Service`,
    },
    specialtyEpisodes: {
        [Locale.Ru]: `Эпизоды специальности`,
        [Locale.Am]: `Մասնագիտության էպիզոդներ`,
        [Locale.En]: `Specialty episodes`,
        [Locale.Pt]: 'Episódios de especialidade',
        [Locale.Ge]: `Specialty episodes`,
    },
    episodeName: {
        [Locale.Ru]: `Название эпизода`,
        [Locale.Am]: `Էպիզոդի անվանում`,
        [Locale.En]: `Episode name`,
        [Locale.Pt]: 'Nome do episódio',
        [Locale.Ge]: `Episode name`,
    },
    editingSpecialityEpisode: {
        [Locale.Ru]: `Редактирование эпизода`,
        [Locale.Am]: `Էպիզոդի խմբագրում`,
        [Locale.En]: `Editing an episode`,
        [Locale.Pt]: 'Editando um episódio',
        [Locale.Ge]: `Editing an episode`,
    },
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
};
